import React from 'react';
import { CheckboxProgressContainer, CheckboxProgressBar, CheckboxProgressFill } from './styles';
import { isCampoVisivel } from '../../utils/validation';

const CheckboxProgress = ({ step, formData }) => {
  const checkboxes = [];
  
  step.sections.forEach(section => {
    section.fields.forEach(field => {
      // Declaração escondida (ex: a das certidões positivas, sem nenhuma marcada)
      // não entra na conta — senão o "X de Y" nunca chegaria ao total.
      if (field.type === 'checkbox' && field.required && isCampoVisivel(field, formData)) {
        const isChecked = formData[field.name] === true;
        checkboxes.push({ label: field.label, checked: isChecked });
      }
    });
  });
  
  if (checkboxes.length === 0) return null;
  
  const checkedCount = checkboxes.filter(cb => cb.checked).length;
  const totalCount = checkboxes.length;
  const allChecked = checkedCount === totalCount;
  const percent = (checkedCount / totalCount) * 100;
  
  return (
    <CheckboxProgressContainer $allChecked={allChecked}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
        <span>{allChecked ? '✅' : '⚠️'}</span>
        <span style={{ fontWeight: 500 }}>
          {allChecked 
            ? 'Todas as declarações aceitas' 
            : `Você precisa aceitar todas as ${totalCount} declarações obrigatórias`}
        </span>
      </div>
      <CheckboxProgressBar>
        <CheckboxProgressFill $allChecked={allChecked} $percent={percent} />
      </CheckboxProgressBar>
      <span style={{ fontSize: '0.8rem', color: '#475569' }}>
        {checkedCount} de {totalCount}
      </span>
    </CheckboxProgressContainer>
  );
};

export default CheckboxProgress;